import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'
import { ToastHost } from '@/shared/ui'
import { AuthGate } from './providers/auth-gate'
import { queryClient } from './providers/query-client'
import { RootErrorBoundary } from './providers/root-error-boundary'
import { createAppRouter } from './router'

let router: ReturnType<typeof createAppRouter> | null = null

/**
 * Один роутер на приложение, созданный при первом рендере — после
 * `applyLaunchTarget()` в `index.tsx`. В модуле, а не в `useState`: StrictMode
 * вызвал бы инициализатор дважды, и второй роутер остался бы слушать историю.
 */
const getRouter = () => {
  router ??= createAppRouter()

  return router
}

export const App = () => (
  <RootErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <AuthGate>
        <RouterProvider router={getRouter()} />
      </AuthGate>
      {/* Тост — поверх любого экрана, в том числе отказных: место одно на приложение. */}
      <ToastHost />
    </QueryClientProvider>
  </RootErrorBoundary>
)
